interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export const navItems2: NavData[] = [
  {
    name: 'Dashboard',
    url: '/proveedores/hilazaredashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    name: 'Salidas',
    url: '/proveedores/hilaza-detail',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    name: 'Titulos',
    url: '/proveedores/hilazatitulo',
    icon: 'icon-speedometer'
  },
  {
    name: 'Referencias',
    url: '/proveedores/hilazareferencia',
    icon: 'icon-speedometer'
  },
  {
    name: 'Hilazas',
    url: '/proveedores/hilazas',
    icon: 'icon-speedometer'
  }
];
